// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// import {stage} from "@/util/stage"
import i18n from "@/util/language";
window.$ = window.jQuery = $;
require("@/util/third/jquery.mCustomScrollbar.min");
require("@/util/third/jquery-ui.min");
import "jquery-mousewheel";
import "babel-polyfill";

import DatePicker from "@/plugins/datePicker";
Vue.use(DatePicker);
import Debounce from "vue-preventedup-plugin";
Vue.use(Debounce, { DebounceTime: 200, ThrottleTime: 200 });
import Notify from "@/plugins/notify";
import Message from "@/plugins/message";
Vue.use(Notify);
Vue.use(Message);
import toast from "@/plugins/toast";
Vue.use(toast);
import uiComponents from "@/plugins/index";
Vue.use(uiComponents);
// import VueAMap from 'vue-amap';
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
// key: '19cacba68756210399cfed0012e65e05',
// plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.ToolBar'],
/// / 默认高德 sdk 版本为 1.4.4
// v: '1.4.4'
// });

import App from "@/App";
import router from "@/router";
import store from "@/store";

import "@/style/main.scss";

import "@/icons";
import "@/permission";

import filters from "@/filters";

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

require("@/directives/permission");

Vue.config.productionTip = false;

// 定义全局点击函数
Vue.prototype.globalClick = function(callBack) {
	document.querySelector("#sideNav").onclick = function() {
		callBack();
	};
};
Vue.prototype.getIn = (state, array, initial = null) => {
	let obj = Object.assign({}, state);
	for (let i = 0; i < array.length; i++) {
		// when is undefined return init immediately
		if (typeof obj !== "object" || obj === null) {
			return initial;
		}
		const prop = array[i];
		obj = obj[prop];
	}
	if (obj === undefined || obj === null) {
		return initial;
	}
	return obj;
};
import Dynamic from "@/plugins/dynamic";
Vue.use(Dynamic, {
	plugin: {
		router,
		store,
		i18n,
		Debounce
	}
});
var eventBus = {
	install(Vue, options) {
		Vue.prototype.$bus = new Vue();
	}
};
Vue.use(eventBus);
/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	store,
	i18n,
	components: { App },
	template: "<App/>"
});
$("body").on("mouseover", ".mCSB_dragger_bar", function() {
	// console.log($(this).parents('.mCSB_scrollTools_onDrag_expand'))
	$(this)
		.parents(".mCSB_scrollTools_onDrag_expand")
		.each(function() {
			// console.log(this)
			$(this).addClass("hasclick");
		});
});
$("body").on("mouseout", ".mCSB_dragger_bar", function() {
	// console.log($(this).parents('.mCSB_scrollTools_onDrag_expand'))
	$(this)
		.parents(".mCSB_scrollTools_onDrag_expand")
		.each(function() {
			// console.log(this)
			$(this).removeClass("hasclick");
		});
});



// WEBPACK FOOTER //
// ./src/main.js